import apiClient from '@admin/lib/auth.client'
import { getCustomHeaders } from '@/components/marketing-landing-page/utils'

const cjrBaseUrl = process.env.NEXT_PUBLIC_CJR_API_BASE_URL
const baseUrl = process.env.NEXT_PUBLIC_API_BASE_URL_AUTH

export const verifyReferralToken = async (): Promise<any> => {
  try {
    const token = new URLSearchParams(window.location.search).get('referralToken')

    if (!token) {
      throw new Error('Token is missing in the URL')
    }

    const response = await fetch(`${cjrBaseUrl}v1/public/referral/verify-token?referralToken=${token}`, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
      },
    })

    if (!response.ok) {
      const errorData = await response.json()
      console.error('Error response:', errorData)
      throw new Error(`Request failed with status ${response.status}`)
    }

    return (await response.json())?.data
  } catch (error) {
    console.error('Error verifying referral token:', error)
    throw error
  }
}

export const fetchReferralUser = async (uniqueCode: string): Promise<any> => {
  try {
    if (!uniqueCode) {
      throw new Error('Unique code is missing')
    }

    const response = await fetch(`${cjrBaseUrl}v1/public/referral/user?uniqueCode=${uniqueCode}`, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
      },
    })

    if (!response.ok) {
      const errorData = await response.json()
      console.error('Error response:', errorData)
      throw new Error(`Request failed with status ${response.status}`)
    }

    return (await response.json())?.data?.firstName
  } catch (error) {
    console.error('Error fetching referral user:', error)
    throw error
  }
}

export const getDiscountFetcher = async (cohortId: string): Promise<any> => {
  try {
    const response = await fetch(
      `${cjrBaseUrl}v1/public/referral/commission-structure?cohortId=${cohortId}`,
      {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
        },
      },
    )

    if (!response.ok) {
      const errorData = await response.json()
      console.error('Error response:', errorData)
      throw new Error(`Request failed with status ${response.status}`)
    }

    return (await response.json())?.data
  } catch (error) {
    console.error('Error fetching discount data:', error)
    throw error
  }
}

export const applyReferCode = async (referCode: string, referralThrough: string): Promise<any> => {
  const token = localStorage.getItem('TOKEN')
  if (!token) {
    console.error('Token is missing in localStorage')
    throw new Error('You are not logged in. Please log in and try again.')
  }

  const customHeaders = getCustomHeaders({ org: 'CJR' })
  return await apiClient.post(
    `${baseUrl}/v1/users/students/apply-refer-code`,
    {
      referCode,
      referralThrough,
    },
    { customHeaders },
  )
}

export const applyCouponCode = async (couponCode: string, type: string, typeIds: string[]): Promise<any> => {
  const token = localStorage.getItem('TOKEN')
  if (!token) {
    console.error('Token is missing in localStorage')
    throw new Error('You are not logged in. Please log in and try again.')
  }

  const customHeaders = getCustomHeaders({ org: 'CJR' })

  return await apiClient.put(
    `${baseUrl}/v1/orders/apply-coupons`,
    {
      couponCode,
      type,
      typeIds,
    },
    { customHeaders },
  )
}

export const addToCart = async (typeId: string) => {
  try {
    const response: any = await apiClient?.post(
      `${process.env.NEXT_PUBLIC_API_BASE_URL_AUTH}/v3/order-management-service/cart`,
      { cartItems: [{ typeId, type: 'BATCH' }] },
      { public: false },
    )
    if (response?.success) {
      return response
    } else {
      throw new Error(response?.error?.message || 'Something went wrong')
    }
  } catch (error) {
    console.error(error)
  }
}

export const getBatchDetails = async ({ batchId }: { batchId: string }): Promise<any> => {
  const customHeaders = getCustomHeaders({ org: 'CJR' })
  const resp = await apiClient.get(`${baseUrl}/v3/batches/${batchId}/details`, {
    public: false,
    customHeaders,
  })
  return resp
}
